import { LocationResourcesWithBooms } from 'types/locations';

export const prettifiedResourceType = (
  resourceType: LocationResourcesWithBooms
) => {
  const addSpaceBeforeCapitalLetters = (str: string) =>
    str.replace(/([A-Z])/g, ' $1');
  const capitalizeFirstLetter = (str: string) =>
    str.charAt(0).toUpperCase() + str.slice(1);
  return capitalizeFirstLetter(addSpaceBeforeCapitalLetters(resourceType));
};
